<template>
  <b-dropdown-divider />
</template>
<script>
export default {};
</script>
